import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXMacchiato = () => (
  <ArticleWrapper articleId="hmx_macchiato">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>HMX Macchiato</h1>
        {/* Add your HMX Macchiato article content here */}
        <p>This is a placeholder article for the HMX Macchiato switch. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default HMXMacchiato;
